module.exports = __webpack_public_path__ + "static/media/onion.7f4194cd.png";